module.exports = __webpack_public_path__ + "img/Sandpoint_full_spread-Roberto-Pitturru.262811e8.jpg";